module.exports = __webpack_public_path__ + "gt.svg?aa33e6773643efd03d382429039986d9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gt.svg
// module id = 824
// module chunks = 27